import { createFileRoute } from '@tanstack/react-router'
import { ResultsPage } from '../components/ResultsPage'

// The current season's results (designs/20261017-seasons.md §4). A season's
// own page is /l/{slug}/s/{n}/results, which is what the app's links use.
// ?post= opens that post's sheet (designs/20261019-comments.md §4).
export const Route = createFileRoute('/l/$slug/results')({
  validateSearch: (s: Record<string, unknown>): { round?: number; post?: number } => ({
    round: typeof s.round === 'number' ? s.round : undefined,
    post: typeof s.post === 'number' ? s.post : undefined,
  }),
  component: Results,
})

function Results() {
  const { slug } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <ResultsPage
      slug={slug}
      round={search.round}
      post={search.post}
      onRound={(round) => navigate({ search: { round }, replace: true })}
      onOpened={() => navigate({ search: (prev) => ({ ...prev, post: undefined }), replace: true })}
    />
  )
}
